export default defineNuxtRouteMiddleware(() => {
    const { clearServerError } = useServerErrorStore();
    clearServerError();
});
